import CryptoJS from 'crypto-js';
const key = "secret-key"; // Replace with your secret key

// Function to format the phone number
const formatPhoneNumber = (value) => {
    if (!value) return value;
    // Remove all non-digit characters
    const phoneNumber = value.replace(/[^\d]/g, "");
    // Format the phone number
    const phoneNumberLength = phoneNumber.length;
    if (phoneNumberLength < 4) return phoneNumber;
    if (phoneNumberLength < 7) {
        return `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(3)}`;
    }
    return `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(3, 6)}-${phoneNumber.slice(6, 10)}`;
};

// Function to check the validate birthdate
const validateBirthDate = (value) => {
    if (!value || value.length !== 10) {
        return false;
    } else {
        return true;
    }
};

const decryptId = (decrypted) => {
    const decryptedId = decrypted?.replace(/p1L2u3S/g, '+').replace(/s1L2a3S4h/g, '/').replace(/e1Q2u3A4l/g, '=');
    const decryptedText = CryptoJS.AES.decrypt(decryptedId, key);
    decrypted = decryptedText?.toString(CryptoJS.enc.Utf8);
    return decrypted;
};

const encryptId = (id) => {
    const encrypted = CryptoJS.AES.encrypt(id.toString(), key).toString();
    return encrypted.replace(/\+/g, 'p1L2u3S').replace(/\//g, 's1L2a3S4h').replace(/=/g, 'e1Q2u3A4l');

};

const encryptShareMixUrl = (token) => {
    // Encrypt and get only the raw ciphertext (no Salted__ prefix)
    const encrypted = CryptoJS.AES.encrypt(token.toString(), key).ciphertext;

    // Encode ciphertext in Base64 (shorter than OpenSSL format)
    return encrypted.toString(CryptoJS.enc.Base64).replace(/\+/g, "p1L2u3S").replace(/\//g, "s1L2a3S4h").replace(/=/g, "e1Q2u3A4l");
};

const decryptShareMixUrl = (token) => {
    const safeToken = token.replace(/p1L2u3S/g, "+").replace(/s1L2a3S4h/g, "/").replace(/e1Q2u3A4l/g, "=");

    const bytes = CryptoJS.AES.decrypt(safeToken, key);
    const decryptedStr = bytes.toString(CryptoJS.enc.Utf8);

    // Parse back into object
    const params = Object.fromEntries(new URLSearchParams(decryptedStr));
    return params;
}

// src/services/trackService.js

const getTrackData = (tracks) => {
    if (!tracks) return { audio: {}, musicAndSounds: [], myMix: [] };

    // Extract audio
    const audio = tracks.audio || {};

    // Extract music + sounds
    const musicAndSounds = tracks?.sounds
        ? [tracks.music, ...tracks.sounds].filter(
            (item) => Object.keys(item || {}).length > 0
        )
        : Object.keys(tracks?.music || {}).length > 0
            ? [tracks.music]
            : [];

    // Extract my mix
    const myMix = tracks.my_mix || [];

    return {
        audio,
        musicAndSounds,
        myMix,
    };
};


export { formatPhoneNumber, validateBirthDate, encryptId, decryptId, encryptShareMixUrl, decryptShareMixUrl, getTrackData }; 